import styled, { css } from 'styled-components';
import { policyColor } from '../../policyColors';

export const DropdownNavWrapper = styled.div``;

export const StyledDropdownNav = styled.div`
  position: relative;
  font-weight: bold;
  z-index: 1;
  perspective: 400px;
`;

export const SelectedItem = styled.div`
  padding: 10px;
  border: 1px solid;
  border-radius: 7px;
  position: relative;
  cursor: pointer;
  color: ${policyColor('navActive')};
  border-color: ${policyColor('navBase')};

  ::before {
    content: ' ';
    position: absolute;
    top: 16px;
    right: 10px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid ${policyColor('navBase')};
  }

  opacity: 0;
  pointer-events: none;
  transform-origin: 50% 0;
  transition-property: opacity;
  transition-duration: 200ms;
  transition-timing-function: ease-in-out;

  ${({ isOpen }) =>
    !isOpen &&
    css`
      opacity: 1;
      pointer-events: all;
    `};

  > * {
    padding: 10px;
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  border: 1px solid;
  border-radius: 7px;
  border-color: ${policyColor('navBase')};
  background-color: ${({ theme }) => theme.colors.white};

  opacity: 0;
  pointer-events: none;
  transform-origin: 50% 0;
  transition-property: opacity;
  transition-duration: 200ms;
  transition-timing-function: ease-in-out;

  ${({ isOpen }) =>
    isOpen &&
    css`
      opacity: 1;
      pointer-events: all;
    `};

  > * {
    padding: 10px;
  }
`;

export const Option = styled.div`
  color: ${policyColor('navBase')};
  cursor: pointer;
`;

export const DropdownTitle = styled.div`
  position: relative;
  color: ${policyColor('navActive')};

  ::before {
    content: ' ';
    position: absolute;
    top: 14px;
    right: 10px;
    width: 0;
    height: 0;
  }
`;
